import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Tab/sgds-tab";
import { register } from "../../utils/ce-registry";

register("sgds-tab", Component);

export default createComponent({
  react: React,
  tagName: "sgds-tab",
  elementClass: Component,
  events: {}
});
